import { ChangeEventHandler } from 'react';
import { Button, FormLabel, Group, IconCrossCircle, Input } from '@screentone/core';

import styles from '../PageModule.module.scss';

interface EditAllesehModuleIdModalProps {
  moduleId: string;
  error: boolean;
  setError: (error: boolean) => void;
  onChange: (moduleId: string) => void;
  disabled?: boolean;
}

const AllessehModuleId = ({
  moduleId = '',
  error,
  setError,
  onChange,
  disabled = false
}: EditAllesehModuleIdModalProps) => {
  const isAlphaNumHyphenUnderscore = /^[a-zA-Z0-9-_]*$/;

  const handleInputValueChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;

    setError(!isAlphaNumHyphenUnderscore.test(value));
    onChange(value);
  };

  const handleClearField = () => {
    setError(false);
    onChange('');
  };

  return (
    <>
      <FormLabel key="moduleId" label="Module ID" fullWidth margin={{ top: 'sm' }} />
      <Group gap="xs" className={styles.inputContainer}>
        <Input
          placeholder="Leave blank for default ID"
          value={moduleId}
          margin={{ bottom: 'sm' }}
          onChange={handleInputValueChange}
          data-testid="edit-module-id"
          error={error}
          disabled={disabled}
        />
        {!disabled && (
          <Button tertiary icon={IconCrossCircle} className={styles.deleteIcon} onClick={handleClearField} />
        )}
      </Group>
    </>
  );
};

export default AllessehModuleId;
